import React from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import LeftPanel from "./include/LeftPanel";
import { ToastContainer } from '../components/ui/toast';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { ProfileEditContent } from "./CustomerEdit";
import { PasswordContent } from "./UpdatePassword";
import { UserCircle, Lock } from "lucide-react";

/**
 * /Profile — consolidated Account hub (Update Profile + Update Password)
 * using the shadcn-style Tabs component, replacing two sidebar items.
 */
function ProfilePage() {
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <h2 className="px-pagehead__title mb-4">Profile</h2>
                    <Tabs defaultValue="profile">
                        <TabsList>
                            <TabsTrigger value="profile"><UserCircle size={15} /> Update Profile</TabsTrigger>
                            <TabsTrigger value="password"><Lock size={15} /> Update Password</TabsTrigger>
                        </TabsList>
                        <TabsContent value="profile">
                            <ProfileEditContent />
                        </TabsContent>
                        <TabsContent value="password">
                            <PasswordContent />
                        </TabsContent>
                    </Tabs>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default ProfilePage;
